import React from 'react';
import classnames from 'classnames'

import throttle from 'lodash/throttle';


const importAll = r => r.keys().map(r);
// Force file-loader because we do not want url-loader to base64-encode all our pngs

// 1860 - 2010
const iframes = importAll(require.context('!file-loader!../mov/bgtest20200313/iframes/', false, /\.jpg$/));
const pframes = importAll(require.context('!file-loader!../mov/bgtest20200313/pframes/', false, /\.png$/));

// 2010 - 2020 (texture fade)
const fade_2010_2020 = [
  require('../mov/bgtest20200313/2010_2020_fade/000.jpg'),
  require('../mov/bgtest20200313/2010_2020_fade/029.jpg'),
];

// 2010 - 2020 (zoom)
const zoom_2010_2020 = importAll(require.context('!file-loader!../mov/bgtest20200313/2020_zoom/', false, /\.jpg$/));


const totalImages = (
  iframes.length +
  pframes.length +
  fade_2010_2020.length +
  zoom_2010_2020.length
);

const total2020Images = fade_2010_2020.length + zoom_2010_2020.length

const IMAGE_WIDTH = 800;
const IMAGE_HEIGHT = 450;

export default class extends React.PureComponent {
  state = {
    canvasRef: React.createRef(),
    context: null,
    loaded: 0
  }

  constructor(props) {
    super(props);
    
    this.load2020Frames()
    this.loadPre2020Frames()
  }

  load2020Frames = () => {
    this.fade_2010_2020 = fade_2010_2020.map(this._load2020Image);
    this.zoom_2010_2020 = zoom_2010_2020.map(this._load2020Image);
  }

  loadPre2020Frames = () => {
    this.iframes = iframes.map(this._loadImage);
    this.pframes = pframes.map(this._loadImage);
  }

  _loaded = 0
  _2020loaded = 0
  _incrementLoaded = () => {
    this._loaded++;
    this._updateLoaded();
  }
  _updateLoaded = throttle(
    () => {
      this.setState(
        { loaded: this._loaded },
        () => {
          this.props.handleProgress((this.state.loaded / totalImages) * 100)
          this.props.handle2020Progress((this._2020loaded / total2020Images) * 100)
        }
      );
    },
    200
  );

  _loadImage = src => {
    const img = new Image();
    img.onload = this._incrementLoaded;
    img.src = src.default;
    return img;
  }

  _load2020Image = src => {
    const img = new Image();
    img.onload = () => {
      this._2020loaded += 1
      this._incrementLoaded();
  
      if (this._2020loaded === total2020Images) {
        this.loadPre2020Frames()
      }
    }

    img.src = src.default;
    return img;
  }

  _resetImage = img => {
    img.src = '';
    img.onload = undefined;
  }

  componentDidMount() {
    this.setState({
      context: this.state.canvasRef.current.getContext('2d'),
    });
  }

  componentWillUnmount() {
    this.iframes.forEach(this._resetImage);
    this.pframes.forEach(this._resetImage);

    this.fade_2010_2020.forEach(this._resetImage);
    this.zoom_2010_2020.forEach(this._resetImage);
  }

  drawFrame = (iframes, pframes, frame, step=15) => {
    const i = ~~(frame / step);
    const j = frame % step;

    this.state.context.drawImage(iframes[i], 0, 0, IMAGE_WIDTH, IMAGE_HEIGHT);

    if (j > 0) {
      const k = (step - 1)*i + j - 1;
      this.state.context.drawImage(pframes[k], 0, 0, IMAGE_WIDTH, IMAGE_HEIGHT);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.frameId === this.props.frameId) return false;

    const n = this.props.frameId;

    if (n >= 450) {
      this.state.context.drawImage(this.zoom_2010_2020[n - 450], 0, 0, IMAGE_WIDTH, IMAGE_HEIGHT);
    } else if (n >= 420) {
      // Draw initial frame
      this.state.context.drawImage(this.fade_2010_2020[0], 0, 0, IMAGE_WIDTH, IMAGE_HEIGHT);

      // Draw last frame, with opacity
      this.state.context.globalAlpha = (n - 420) / 30; // eslint-disable-line react/no-direct-mutation-state
      this.state.context.drawImage(this.fade_2010_2020[1], 0, 0, IMAGE_WIDTH, IMAGE_HEIGHT);

      // Reset global opacity to 1
      this.state.context.globalAlpha = 1; // eslint-disable-line react/no-direct-mutation-state
    } else {
      this.drawFrame(this.iframes, this.pframes, n);
    }
  }

  // 800x450
  // 640x360
  render() {
    return (
      <canvas ref={this.state.canvasRef} width={IMAGE_WIDTH} height={IMAGE_HEIGHT}
        className={classnames('hero opacity-animated', {
          exited: this.props.hide
        })}>
      </canvas>
    );
  }
}